import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { handleChangeDataModalRejectFactor } from '../../../../redux/actions/partials/modals/modalRejectFactor';
import { handleChangeInputInstallmentsFactorPage } from '../../../../redux/actions/pages/installments_factor';
import { BASE_SITE, REJECT_INSTALLMENTS_FACTOR } from '../../../../apis';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import axios from "axios";
import * as qs from "querystring";


const ModalRejectFactor = (props) => {

	const dispatch = useDispatch();

	const { isOpen, rejectReason, factorNum, factorKey } = useSelector(state => state.modalRejectFactor);
	const { factors } = useSelector(state => state.installmentsFactor);
	const { token } = useSelector(state => state.login);

	const handleClose = () => {
        dispatch(handleChangeDataModalRejectFactor('isOpen', false));
    };    

    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalRejectFactor(name, value));
    };

    const handleSubmitForm = () => {
    	dispatch(handleSetBackdropLoading(true));


    	axios({
            method: 'post',
            url: BASE_SITE + REJECT_INSTALLMENTS_FACTOR,
            data: qs.stringify({
                factor: factorNum,
                reason: rejectReason,
            }), headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded', 
                'Authorization': token, 
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                	dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                    break;
                case 'ok':
                	dispatch(handleSetOpenCustomSnackbar(true, {message: 'فاکتور مورد نظر با موفقیت لغو شد', severity: 'success', vertical: 'top', horizontal: 'right'}));

                	let newFactors = factors.filter((item, index) => index !== factorKey);
                	dispatch( handleChangeInputInstallmentsFactorPage('factors', newFactors) );

                    dispatch(handleChangeDataModalRejectFactor('factorNum', 0));
                    dispatch(handleChangeDataModalRejectFactor('factorKey', 0));
                    dispatch(handleChangeDataModalRejectFactor('rejectReason', ''));
                    dispatch(handleChangeDataModalRejectFactor('isOpen', false));

                    break;
                default:
                	dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            dispatch(handleSetBackdropLoading(false));
        });
    };

    return (
        <Modal show={isOpen} onHide={handleClose} className={`modal fade text-xs-left ${isOpen ? 'in' : ''}`} dialogClassName='modal-dialog modal-dialog-centered modal-fullscreen-sm-down' style={{marginTop: '90px'}}>
        	<div className="modal-dialog modal-lg" role="document" style={{marginTop: '0', marginBottom: '0'}}>
        		<div className="modal-content" >
        			<div className="modal-header">
		                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                <h4 className="modal-title" id="myModalLabel17">لغو فاکتور اقساطی</h4>
		            </div>
		            <form>
			            <div className="modal-body">
			            	<label>دلیل لغو</label>
							<div className="form-group">
								<input type="text" placeholder="" className="form-control" name="rejectReason" value={rejectReason} onChange={handleChangeInputs} />
							</div>
			            </div>
			            <div className="modal-footer">
			                <button type="button" className="btn grey btn-outline-secondary" data-dismiss="modal" onClick={handleClose}>بستن</button>
			                <button type="button" className="btn btn-outline-primary ml-2" data-dismiss="modal" onClick={handleSubmitForm}>لغو فاکتور</button>
			            </div>
		            </form>
        		</div>
        	</div>

        </Modal>
    );
}

export default ModalRejectFactor;
